import { Fragment } from 'react'
import { Row } from 'react-bootstrap'
import FormIcon from '../../Layouts/Forms/FormIcon'

const InvoiceAddress = (props) => {
    const {address, changeAddress} = props;
    return (
        <Fragment>
            <Row className='mb-3'>
                <FormIcon title='Calle' name='street' value={address?.street} handleChange={changeAddress} />
                <FormIcon title='Número interior' name='interior' value={address?.interior} handleChange={changeAddress} />
                <FormIcon title='Número exterior' name='exterior' value={address?.exterior} handleChange={changeAddress} />
            </Row>
            <Row className='mb-3'>
                <FormIcon title='Colonia' name='neighborhood' value={address?.neighborhood} handleChange={changeAddress} />
                <FormIcon title='Municipio' name='municipality' value={address?.municipality} handleChange={changeAddress} />
                <FormIcon title='Ciudad' name='city' value={address?.city} handleChange={changeAddress} />
            </Row>
            <Row className='mb-3'>
                <FormIcon title='Código postal' name='zip' value={address?.zip} handleChange={changeAddress} />
                <FormIcon title='Estado' name='state' value={address?.state} handleChange={changeAddress} />
                <FormIcon title='País' name='country' value={address?.country} handleChange={changeAddress} />
            </Row>
        </Fragment>
    )
}

export default InvoiceAddress